import WordHighlightMenu from './WordHighlightMenu';

/**
 * StudentPassageActions — single entry point for student quick-actions on
 * a passage. Symmetric with TeacherPassageActions but scoped to what a
 * student should be able to do:
 *
 *   • Single-word selection → "Add to my list" (personal vocab list)
 *
 * Sentence-analyze is intentionally NOT included. Student access to
 * Sentence Studio is a separate feature decision; revisit when ready.
 *
 * Props:
 *   chapterId — BookChapter id, used as `source_reference_id` for
 *               provenance on the new UserWordCard.
 *   children  — the passage region.
 */
export default function StudentPassageActions({
  chapterId,
  children,
}) {
  return (
    <WordHighlightMenu
      userRole="student"
      sourceType={chapterId ? 'BookChapter' : null}
      sourceId={chapterId || null}
    >
      {children}
    </WordHighlightMenu>
  );
}
